/**
 * A saved workspace, as a URL carries it.
 *
 * ITS OWN MODULE because the rail's workspace links are on every page. While these lived in
 * `WorkspaceMenu.tsx`, that import put the whole menu — and Radix Popover with floating-ui behind
 * it — in the entry chunk, although the menu itself only ever renders on a list page. Rollup
 * tree-shakes across the graph, not per chunk (DESIGN_SYSTEM.md §8, 2026-10-01).
 */

// `&` when the route is a tab that already carries its own query — `/bills?tab=tenancy`.
export const workspaceHref = (route: string, id: string) =>
  `${route}${route.includes('?') ? '&' : '?'}workspace=${encodeURIComponent(id)}`;

/**
 * The workspace a URL is asking for, if any.
 *
 * Exported because route loaders read it too: a list opened at `?workspace=…` is about to be
 * re-filtered by that saved view, so prefetching the DEFAULT view first is a round trip whose
 * answer is thrown away. One definition, so the loader and the hook cannot disagree about
 * whether a workspace was asked for.
 */
export function workspaceFromHref(href: string): string | null {
  return new URL(href, window.location.origin).searchParams.get('workspace');
}
